import React from 'react';

import { TableColumns } from '@models/column';
import { FeatureDescriptor } from '@models/feature-descriptor';

import { AggregationEditor } from './AggregationEditor';
import { FilterEditor } from './FilterEditor';
import { JoinEditor } from './JoinEditor';

const FeatureOperationEditorWrapper = (props: {
  label: string;
  children: React.ReactNode;
}) => {
  return (
    <div style={{ display: 'flex' }}>
      <span
        style={{
          width: '110px',
          marginRight: '5px',
          lineHeight: '26px',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <span style={{ marginLeft: '20px' }}>{props.label}</span>
        <span className="equal-sign">=</span>
      </span>
      {props.children}
    </div>
  );
};

export const FeatureDescriptorEditor = (props: {
  featureDescriptor: FeatureDescriptor;
  tableColumns: TableColumns;
}) => {
  return (
    <div className="feature-descriptor-editor">
      FeatureDescriptor(
      <FeatureOperationEditorWrapper label="join">
        <JoinEditor tableColumns={props.tableColumns} />
      </FeatureOperationEditorWrapper>
      <FeatureOperationEditorWrapper label="filter">
        <FilterEditor tableColumns={props.tableColumns} />
      </FeatureOperationEditorWrapper>
      <FeatureOperationEditorWrapper label="aggregation">
        <AggregationEditor tableColumns={props.tableColumns} />
      </FeatureOperationEditorWrapper>
      )
    </div>
  );
};
